<template >
  <div class="component-container">
    <app-navigation v-if="!$props.onlyMaps"></app-navigation>
    <div class="main-div">
      <form>
        <div class="demo text-left">
          <div class="p-2 header">
            <h3 class="text-left">Products Sizes </h3>
          </div>
          <div class="row mt-3">
            <div class="col-md-6">
              <div class="form-group">
                <label class="label text-left">Size Name</label>
                <input
                  type="text"
                  v-model="size.name_ar"
                  class="form-control"
                  required
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label class="label text-left">Size Name (EN)</label>
                <input
                  type="text"
                  v-model="size.name_en"
                  class="form-control"
                  required
                />
              </div>
            </div>
          </div>
        </div>
        <button
          class="btn btn-primary float-right m-4"
          v-if="!formState.loading"
          @click="addSize"
        >
          Add Size
        </button>
        <button
          class="btn btn-primary float-right m-4"
          type="button"
          disabled
          v-else
        >
          <span
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
          Loading
        </button>
      </form>
      <div class="alert alert-danger" role="alert" v-if="formState.error">
        {{ formState.error }}
      </div>
      <table class="table mt-5">
        <thead class="thead-light table-striped table-hover">
          <tr>
            <th scope="col">#</th>
            <th scope="col">Name</th>
            <th scope="col">Name En</th>
            <th scope="col">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="size in sizes" :key="size.id">
            <th scope="row">{{size.id}}</th>
            <td>{{size.name_ar}}</td>
            <td>{{size.name_en}}</td>
            <td><span class="badge badge-danger p-2" @click="deleteSize(size.id)"><i class="fa fa-trash" aria-hidden="true"></i></span></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import Navigation from "../components/Navigation.vue";
import axios from "axios";
import { herokuUrl } from "../apiConfig";
import { getCookie } from "../cookie.js";
import logOut from "../scripts/utils";

export default {
  props: ["onlyMaps"],
  name: "Demo",

  data() {
    return {
      size: {},
      sizes: [],
      formState: {
        loading: false,
        error: null,
      },
    };
  },
  mounted() {
    this.getsizes();
  },
  methods: {
    getsizes: function () {
      this.formState.loading = true;
      return Promise.all([
        axios.get(`${herokuUrl}/sizes`, null, {
          headers: {
            Authorization: getCookie("user"),
          },
        }),
      ])
        .then((res) => {
          console.log(res);
          this.sizes = res[0].data["sizes"];
          this.formState.loading = false;
        })
        .catch((err) => {
            console.log(err);
        });
    },
    addSize: function () {
      this.formState.loading = true;
      if (
        !this.size.name_ar ||
        !this.size.name_en
      ) {
        this.formState.error = "All Fields Are Required";
        this.formState.loading = false;
        return;
      } else {
        // console.log("submitted" , this.size.name_ar);
        return axios
          .post(`${herokuUrl}/create_size`, this.size, {
            headers: {
              Authorization: getCookie("user"),
            },
          })
          .then(() => {
            alert("size Has Been Added Successfully");
            this.size = {};
            this.getsizes();
            this.formState.loading = false;
          })
          .catch((err) => {
            if (err.response.status == 401) {
              logOut();
            } else {
              this.formState.loading = false;
              alert(
                "There was a problem when adding size " +
                  err.response.data.message
              );
            }
          });
      }
    },
    deleteSize: function(id){
      this.formState.loading = true;
        console.log("submitted" + id);
        return axios
          .post(`${herokuUrl}/delete_size`, {id: id}, {
            headers: {
              Authorization: getCookie("user"),
            },
          })
          .then(() => {
            alert("size Has Been Deleted Successfully");
            this.size = {};
            this.getsizes();
            this.formState.loading = false;
          })
          .catch((err) => {
            if (err.response.status == 401) {
              logOut();
            } else {
              this.formState.loading = false;
              alert(
                "There was a problem when Deleting size " +
                  err.response.data.message
              );
            }
          });
    }
  },

  components: {
    appNavigation: Navigation,
  },
};
</script>
<style lang='scss' scoped>
@import "../../node_modules/bootstrap/scss/bootstrap.scss";
.component-container {
  min-height: 100%;
  display: flex;
}

.main-div {
  padding: 50px;
  width: 80%;

  button {
    margin: 0 auto;
    padding: 10px 30px;
    font-size: 16px;
  }

  .header {
    padding-top: 16px !important;
    background: black;
    color: #b78b1e;
  }
}
</style>